import { Injectable } from '@angular/core';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { EnvService } from './env.service';
import { CallBackTransformService } from './call-back-transform.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  public notificationBellCount = new BehaviorSubject<number>(null);
  constructor(
    private envService: EnvService,
    private http: HttpClient,
    private callBackTransformService: CallBackTransformService
  ) { }

  /**
 * notification list
 * @param Object none
 * @return Object Resultset
 */

  getPresentNotification(personIndex): Observable<any>  {
    const url = this.envService.apiUrl + 'risk-notifications/' + personIndex;
    return this.http.get<any>(url).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  /**
   * present notification list
   * @param personIndex : the person index
   * @param searchObject : the search object
   * @return Object Resultset
   */

  getPresentNotificationList(personIndex, searchObject): Observable<any>  {
    const url = this.envService.apiUrl + 'present-notification-list/' + personIndex;
    return this.http.post<any>(url, searchObject).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  /**
   * present notification list
   * @param personIndex : person index
   * @param searchObject : search object
   * @return Object Resultset
   */

  getPastNotificationList(personIndex, searchObject): Observable<any>  {
    const url = this.envService.apiUrl + 'past-notification-list/' + personIndex;
    return this.http.post<any>(url, searchObject).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  getPastNotification(personIndex): Observable<any>  {
    const url = this.envService.apiUrl + 'past-notifications/' + personIndex;
    return this.http.get<any>(url).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }
  getPastNote(id, paginationParam): Observable<any>  {
    const url = this.envService.apiUrl + 'past-notes/' + id + '/'  + paginationParam.pageNumber + '/' + paginationParam.pageLimit ;
    return this.http.get<any>(url).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }
  updateStatus(notificationLogID, status): Observable<any>  {
    const url = this.envService.apiUrl + 'update-notification-status/' + notificationLogID + '/'  + status  ;
    return this.http.put<any>(url, notificationLogID, status).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  getNotificationCount(): Observable<any> {
    const url = this.envService.apiUrl + 'notification-count';
    return this.http.get<any>(url).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }
  updateNotificationViewDate(): Observable<any> {
    const url = this.envService.apiUrl + 'user-notification-viewon';
    return this.http.put<any>(url, {}).pipe(
      map((output) => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }
  
  setNotificationBellCount(notificationCount) {
    this.notificationBellCount.next(notificationCount);
  }

}


